module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-duotone-regular-400.woff2";